import React from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import Yupup from "../../../assets/icons/newLogo.svg";
import YupupScreen from "./../../../assets/icons/blackLogo.svg";
import HeroImage from "../../../components/common/HeroImage";

const Thankyou = ({ heading, paragraph }) => {
  return (
    <div className="flex flex-col justify-center items-center h-screen overflow-hidden  bg-primaryPurple lg:bg-white lg:grid lg:grid-cols-2">
      <div className="grid grid-cols-1 lg:content-center lg:justify-items-start lg:px-10">
        <div className="object-cover flex flex-row justify-center ">
          <img
            className="block sm:block md:block lg:hidden xl:hidden"
            alt="yupup-logo"
            src={Yupup}
          />
        </div>
        <div className="object-cover mb-10">
          <img
            className="hidden sm:hidden md:hidden lg:block xl:block xl:h-13 "
            alt="yupup-screen-logo"
            src={YupupScreen}
          />
        </div>
        <div className="flex flex-col space-y-3 items-center px-5 text-white lg:text-black lg:px-0 lg:items-start">
          <div className="w-96">
            <p
              className="lg:text-start"
              style={{
                color: colors.background,
                fontFamily: "Satoshi-Regular, Helvetica",
                fontSize: "24px",
                fontWeight: 300,
                letterSpacing: "0.09px",
                lineHeight: "1.5",
              }}
            >
              {heading}
            </p>
          </div>
          <div className="lg:text-start">
            <p
              className="font-light"
              style={{
                color: colors.textBlack,
                fontFamily: "var(--subtitle-0-font-family)",
                fontSize: "var(--subtitle-0-font-size)",
                letterSpacing: "var(--subtitle-0-letter-spacing)",
                lineHeight: "var(--subtitle-0-line-height)",
                height: "50px",
                left: 0,
              }}
            >
              {paragraph}
            </p>
          </div>
          <div>
            <Link to="/login" className="no-underline">
              <Button
                title="Done"
                color={colors.primaryPurple}
                className="w-31 md:w-40 lg:w-40 xl:w-40"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden w-full justify-end lg:flex ">
        <HeroImage signup={true} />
      </div>
    </div>
  );
};

export default Thankyou;
